import { render, staticRenderFns } from "./InvoicePrint.template.vue?vue&type=template&id=2f96a490&scoped=true&"
var script = {}
import style0 from "./InvoicePrint.template.vue?vue&type=style&index=0&id=2f96a490&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f96a490",
  null
  
)

export default component.exports